export default __webpack_public_path__ + "static/media/20 [Converted]@2x.94e7edf8.png";